import { beginApiCall, apiCallError } from "./apiStatusActions";
import {
  VERIFY_USER,
  LOGOUT_USER,
  LOAD_USER_SUCCESS,
  ADD_USER_ID,
  CLEAR_USER,
  LOAD_PROFILE,
  LOAD_REGAN_RAE_FAVORITES,
  VERIFY_NOTHING,
} from "./actionTypes";
import * as userProfileApi from "../../api/userProfileApi";
import { loadRecipesSuccess } from "./recipeActions";

export const loadUser = () => {
  return async function (dispatch) {
    const token = sessionStorage.getItem("cb_token");
    const res = await userProfileApi.getUser(token);
    const data = await res.data[0];
    const { displayName, email, firebase_uid } = data;
    dispatch({
      type: VERIFY_USER,
      payload: { displayName, email, firebase_uid, signedIn: true },
    });
  };
};

export const fetchUserByEmail = async (email, recipeId) => {
  const token = sessionStorage.getItem("cb_token");
  const res = await userProfileApi.fetchUserByEmail(token, email, recipeId);
  const data = await res;
  return data;
};

export const loadUserProfile = () => {
  return async function (dispatch) {
    const token = sessionStorage.getItem("cb_token");
    const res = await userProfileApi.getUserProfile(token);
    const data = await res.data;
    const { _id, favorites, friends } = data;
    dispatch({
      type: LOAD_PROFILE,
      payload: { _id, favorites, friends },
    });
  };
};

export const loadReganAndRaeFavorites = () => {
  return async function (dispatch) {
    const raeRes = await userProfileApi.getUserProfileById(
      "JK0Qqi5SD3d8PgslByJRdsuLlHa2"
    );
    const reganRes = await userProfileApi.getUserProfileById(
      "JxBY0edAIibD6aTiQCyxEPUTU642"
    );
    const raeData = await raeRes.data;
    const reganData = await reganRes.data;
    const favorites = raeData.favorites.concat(reganData.favorites);
    dispatch({
      type: LOAD_REGAN_RAE_FAVORITES,
      payload: favorites,
    });
  };
};

export const clearUser = () => {
  return function (dispatch) {
    dispatch({ type: CLEAR_USER });
  };
};

export function verifyUser() {
  return { type: VERIFY_USER };
}

export function addUserId(id) {
  return { type: ADD_USER_ID, id };
}

export function loadVisitingUserSuccess(user) {
  return { type: LOAD_USER_SUCCESS, user };
}

export function signout() {
  return function (dispatch) {
    dispatch({ type: LOGOUT_USER });
  };
}

export function collectLocalStorageValues() {
  return new Promise((resolve, reject) => {
    const token = window.localStorage.getItem("token");
    const username = window.localStorage.getItem("username");
    const id = window.localStorage.getItem("userID");
    if (!token || !username) reject("No token or username");
    resolve({ token, username, id });
  });
}

export function getUserData() {
  if (window.localStorage.userData) {
    return Promise.resolve(JSON.parse(window.localStorage.userData));
  } else {
    return Promise.reject({ err: "no user data" });
  }
}

export function loadUserFromParams(name, slug) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return userProfileApi
      .getUserByName(name)
      .then((user) => {
        dispatch(loadVisitingUserSuccess(user.data));
        if (slug) {
          const matchingRecipe = user.data.recipes.filter(
            (recipe) => recipe.slug === slug
          );
          if (matchingRecipe.length === 0)
            return Promise.reject("Invalid slug");
        }

        dispatch(loadRecipesSuccess(user.data.recipes));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
